module.exports = __webpack_public_path__ + "img/logo-sd-ts.5c49b37b.png";